<button class="btn btn-outline btn-error" (click)="onClick()">
    <i class="material-symbols-outlined"> delete </i>
    <span>{{text}}</span>
  </button>